<template>
  <div class="delivery">
    <div class="container">
      <div class="delivery-toogle" v-bind:class="{ visbility: !visbility }" v-on:click=onToogleClick>
        <img :src="i">
      </div>
      <div class="delivery-info" data-simplebar v-bind:class="{ visbility: visbility }">
        <div class="delivery-info-close" v-on:click=onToogleClick>&times;</div>
        <h1 >
          Доставка
        </h1>
        <p>
          Мы осуществляем доставку по г. Чите ежедневно с 12:00 до 22:00
        </p>
        <h2>
          Стоимость доставки
        </h2>
        <div class="delivery-cost" style="background-color: rgba(237, 69, 67, 0.6);"></div><h3>0 ₽ - Бесплатно</h3>
        <p>
          Центральный р-н, Ингодинский р-н
        </p>
        <div class="delivery-cost" style="background-color: rgba(14, 71, 121, 0.3);"></div><h3>100 ₽</h3>
        <p>
          Отдаленные районы
        </p>
        <div class="delivery-cost" style="background-color: rgba(27, 173, 3, 0.3);"></div><h3>200 ₽</h3>
        <p>
          Отдаленные районы
        </p>
        <div class="delivery-cost" style="background-color: rgba(230, 118, 27, 0.3);"></div>
        <h3>300 ₽</h3>
        <p>
          Отдаленные районы
        </p>
        <h2>
          Адрес самовывоза
        </h2>
        <p>
          ул. Богомягкова, 12а, ТЦ Меркурий, Кафе
        </p>
      </div>
      <div class="delivery-info-button-box" v-bind:class="{ visbility: visbility }">
        <div class="delivery-info-button" v-on:click=onToogleClick >Закрыть</div>
      </div>
    </div>
    <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3A282603250ee0ec4e6502537b8bf7f887593387ef9417e8abbe55dff82339528e&amp;source=constructor" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>

<script>
// @ is an alias to /src
import i from '@/assets/i.svg'

export default {

  name: 'delivery',
  data() {
    return {
      visbility: true,
      i: i
    }
  },
  beforeMount (){
    document.body.classList.add("height");// it needs for yandex map to fit in 100% of height
    if (window.screen.width < 960) {
      this.visbility = false
    }
  },
  beforeDestroy() {
    document.body.classList.remove("height"); // it need for sticky album navigation
  },
  methods: {
    onToogleClick(){
      this.visbility = !this.visbility
    }
  }

}
</script>

<style lang="scss">

.delivery{
  height: calc(100% - 160px);
  .container{
    display: flex;
    flex-direction: row-reverse;
    padding-right: 10px;
    .delivery-toogle{
      display: none;
      &.visbility{
        display: flex;
        align-items: center;
         justify-content: center;
      }
      position: fixed;
      margin-top: 10px;
      height: 60px;
      width: 60px;
      border: 1px solid transparent;
      background-color: white;
      box-shadow: 0 1px 2px 1px rgba(0,0,0,.1), 0 2px 5px -3px rgba(0,0,0,.1);
      border-radius: 8px;
      cursor: pointer;
      line-height: 60px;
      font-size: 25px;
      background-color: white;
      img{
        height: 30px;
        width: 30px;
        svg{
          fill: aqua;
        }
      }
    }
    .delivery-info{
      display: none;
      &.visbility{
        display: block;
      }
      border: 1px solid transparent;
      position: fixed;
      margin-top: 10px;
      width: 400px;
      background-color: white;
      padding: 15px 15px 0 15px;
      border-radius: 4px;
      max-height: calc(100% - 190px);
      box-shadow: 0 1px 2px 1px rgba(0,0,0,.05), 0 2px 5px -3px rgba(0,0,0,.05);
      z-index: 5;
      .delivery-cost{
        float: left;
        width: 20px;
        height: 10px;
        margin-top: 4px;     
        margin-right: 10px;
        border-radius: 2px;
      }
      .delivery-info-close{
        height: 30px;
        width: 30px;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
        position: relative;
        float: right;
        top: -5px;
        font-size: 20px;
        border-radius: 30px;
        background-color: white;
        color: #aaa;
        border: 1px solid transparent;
        box-shadow: 0 1px 2px 1px rgba(0,0,0,.2), 0 2px 5px -3px rgba(0,0,0,.2);
      }
    }
    .delivery-info-button-box{
      display: none;
    }
  }
}

@media only screen and (max-width: 959px){
  .delivery{
    height: calc(100% - 60px);
    .container{
      display: block;
      padding: 0;
      .delivery-toogle{
        bottom: 53px;
        left: 8px;
      }
      .delivery-info{
        width: 100%;
        max-height: calc(100% - 60px);
        bottom: 60px;
        background-color: white;
        border-radius: 0;
        padding: 15px 15px 0 10px;
        .delivery-info-close{
          display: none;
        }
      }
      .delivery-info-button-box{
        width: 100%;
        background-color: white;
        position: fixed;
        bottom: 0;
        padding: 10px;
        display: none;
        z-index: 5;
        &.visbility{
          display: block;
        }
        .delivery-info-button{
          text-align: center;
          border-radius: 5px;
          border: 1px solid #aaa;
          background-color: white;
          padding: 10px 14px;
          font-size: 16px;
          width: 100px;
          margin: 0 auto;
        }
      }
    }

    h1,h2{
      text-align: center;
    }
  }
}

</style>